import { noop } from 'helpers/utils'

export const scrollHelper = async ({ handler = noop, scrollPadding = 0, infinityRef }) => {
  if (infinityRef) {
    const { top = 0, bottom = 0 } = infinityRef.getBoundingClientRect() || {}
    if ((top >= 0 || top - scrollPadding >= 0) &&
      (bottom <= window.innerHeight || bottom - scrollPadding <= window.innerHeight)) {
      try {
        await handler()
      } catch (e) {
        console.log(e)
      }
    }
  }
}
